module.exports = __webpack_public_path__ + "static/blog-hero-bffd86936446157cf6d16965b76465a3.jpg";